import CT from "../assets/images/imagin_img_1.jpg";
import densitometry from "../assets/images/imagin_img_9.jpg";
import MAMMOGRAPHY from "../assets/images/imagin_img_2.jpg";
import DIGITALXRAY from "../assets/images/imagin_img_4.jpg";
import ECHOCARDIOGRAPHY from "../assets/images/imagin_img_3.jpg";
import NUCLEARMEDICINE from "../assets/images/imagin_img_8.jpg";
import MRI from "../assets/images/imagin_img_6.jpg";
import PET from "../assets/images/imagin_img_5.jpg";
import ULTRASOUND from "../assets/images/imagin_img_7.jpg";

// Shaped Images for imagin services 

import CTShaped from "../assets/images/CT.png";
import BoneShaped from "../assets/images/DEXA Scan.png";
import MAMMOGRAPHYShape from "../assets/images/3D Mammography.png";
import DIGITALXRAYShape from "../assets/images/Digital X-Ray.png";
import ECHOCARDIOGRAPHYShape from "../assets/images/Echocardiography.png";
import NUCLEARMEDICINEShape from "../assets/images/Nuclear Medicine.png";
import MRIShape from "../assets/images/High-Field.png";
import PETShape from "../assets/images/PET.png";
import ULTRASOUNDShape from "../assets/images/Ultrasound.jpg";

import CTScanVdo from "../assets/video/0_Cancer_Mri_3840x2160.mp4";
import CTScanVdo2 from "../assets/video/6463471_Doctor_Hospital_1920x1080.mp4";

import dexz_vdo_1 from "../assets/video/dexz_vdo_1.mp4";
import dexz_vdo_2 from "../assets/video/dexz_vdo_2.mp4";

import d_manman_1 from "../assets/video/3d_manman_1.mp4";
import d_manman_2 from "../assets/video/3d_manman_2.mp4";

import digital_xray_1 from "../assets/video/digital_xray_1.mp4";
import digital_xray_2 from "../assets/video/digital_xray_2.mp4";

import cardio_vdo_1 from "../assets/video/cardio_vdo_1.mp4";
import cardio_vdo_2 from "../assets/video/cardio_vdo_2.mp4";

import nuclear_1 from "../assets/video/nuclear_1.mp4";
import nuclear_2 from "../assets/video/nuclear_2.mp4";

import high_mri_1 from "../assets/video/high_mri_1.mp4";
import high_mri_2 from "../assets/video/high_mri_2.mp4";

import ultrasound_1 from "../assets/video/ultrasound_1.mp4";
import ultrasound_2 from "../assets/video/ultrasound_2.mp4";
const imagingServicesdata = [
  {
    image: CT,
    alt: "CT Scan",
    title: "Computed Tomography",
    subTitle:
      "Computed Tomography, for short, is also referred to as a CT scan.",
    slug: "computed-tomography",
    extraTopMargin: true,
    bottomTextAbsolute: false,
    description: "Detailed body imaging using computer-processed X-rays.",
    shapedImg: CTShaped,
    content: [
      {
        heading: "What is a CT Scan?",
        text: `Computed Tomography, for short, is also referred to as a CT scan.A CT scan is an imaging medical technology that assists physicians in viewing the internal human body structures in a very clear way without undergoing any surgical procedure.`,
        video: CTScanVdo,
      },
      {
        heading: "How does it work?",
        text: `This technology is currently commonly applied both during diagnosis and in emergencies. CT scans are used to diagnose several conditions and disorders, like tumors, internal injuries, infections, blood clots, cardiovascular disease, fractures, and abnormalities in the human brain.
                A CT scan provides cross-sectional images that are far more detailed than any standard X-ray examination.
                While taking the CT scan test, the patient will lie on a slowly moving table that goes into a big circular machine known as a CT scanner. An X-ray source scans around the body, taking aerial pictures from various directions, and these are sorted by powerful computers to provide a whole 3D image.
                Contrast dye may be ingested or injected to highlight internal structures. The scan uses low-dose ionising radiation. Newer machines aim to minimise risk while maximising diagnostic clarity.
                CT scanning is quick, painless, and highly informative—one of the pillars of modern medicine.`,
        video: CTScanVdo2,
      },
      {
        heading: "Conditions a CT Scan can Detect",
        text: `A CT scan can detect various conditions like `,
        points: [
          "Tumors of cancer",
          "Fractures",
          "Internal bleeding caused due to accidents",
          "Detects kidney stones",
          "Lung diseases",
          "Detects abnormalities in the brain",
        ],
      },
      {
        heading: "Common uses of CT Scan",
        text: `CT scans provide quick and detailed images and identify various medical conditions within the body. They are commonly used for `,
        points: [
          "Diagnosing injuries",
          "Identifying tumours",
          "Assessing infections",
          "Evaluating blood vessels",
          "Assessing the brain",
          "Diagnosing, detecting and monitoring diseases",
        ],
      },
      {
        heading: "Benefits of a CT scan",
        points: [
          "It provides clear, precise and detailed images of internal organs and structures.",
          "It typically takes just a few minutes for a complete diagnosis, and it is a non-invasive procedure.",
          "It helps in identifying a wide range of conditions like tumours, fractures, infections, and more.",
          "It provides 3D images for better assessment with accurate results.",
          "It provides fast results in case of emergencies.",
        ],
      },
      {
        heading: "What to expect after a CT Scan?",
        text: `However, CT scan is the quickest, painless and safest procedure, but depending on the type of CT scan you have undergone, your physician will ask you to follow some precautions. Following are some of the simple things your doctor will advise you to do-
 `,
        points: [
          "In case of a contrast scan, you will have to drink plenty of water for 24 hours before to flush out the dye used in the procedure.",
          "Acute reactions like redness, itching or irritation may be felt, but if you experience dizziness or difficulty in breathing, then immediately consult your doctor.",
          "Your reports will be available within 24-48 hours, and your primary doctor will explain to you the conditions.",
          "Most people resume their daily activities right after the scan. Few may feel a mild headache, which often goes away on its own.",
        ],
      },
      {
        heading: "How safe are the CT scans at the CDC?",
        text: `Although it uses radiation, the levels are controlled in such a way that which is considered safe for patients.
             However, it is prohibited for pregnant women unless and until it is extremely needed.
             It is a modern, advanced medical technology providing detailed images to help doctors diagnose, monitor and treat a wide range of medical conditions.
`,
      },
    ],
    whatIs: {
      heading: "What is a CT Scan?",
      text: `Computed Tomography, for short, is also referred to as a CT scan.A CT scan is an imaging medical technology that assists physicians in viewing the internal human body structures in a very clear way without undergoing any surgical procedure.`,
      video: CTScanVdo,
    },
    howWork: {
      heading: "How does it work?",
      text: `This technology is currently commonly applied both during diagnosis and in emergencies. CT scans are used to diagnose several conditions and disorders, like tumors, internal injuries, infections, blood clots, cardiovascular disease, fractures, and abnormalities in the human brain.
                A CT scan provides cross-sectional images that are far more detailed than any standard X-ray examination.
                While taking the CT scan test, the patient will lie on a slowly moving table that goes into a big circular machine known as a CT scanner. An X-ray source scans around the body, taking aerial pictures from various directions, and these are sorted by powerful computers to provide a whole 3D image.
                Contrast dye may be ingested or injected to highlight internal structures. The scan uses low-dose ionising radiation. Newer machines aim to minimise risk while maximising diagnostic clarity.
                CT scanning is quick, painless, and highly informative—one of the pillars of modern medicine.`,
      video: CTScanVdo2,
    },
    conditions: {
      heading: "Conditions a CT Scan can Detect",
      text: `A CT scan can detect various conditions like `,
      points: [
        "Tumors of cancer",
        "Fractures",
        "Internal bleeding caused due to accidents",
        "Detects kidney stones",
        "Lung diseases",
        "Detects abnormalities in the brain",
      ],
    },
    usecase: {
      heading: "Common uses of CT Scan",
      text: `CT scans provide quick and detailed images and identify various medical conditions within the body. They are commonly used for `,
      points: [
        "Diagnosing injuries",
        "Identifying tumours",
        "Assessing infections",
        "Evaluating blood vessels",
        "Assessing the brain",
        "Diagnosing, detecting and monitoring diseases",
      ],
    },
    benefits: {
      heading: "Benefits of a CT scan",
      points: [
        "It provides clear, precise and detailed images of internal organs and structures.",
        "It typically takes just a few minutes for a complete diagnosis, and it is a non-invasive procedure.",
        "It helps in identifying a wide range of conditions like tumours, fractures, infections, and more.",
        "It provides 3D images for better assessment with accurate results.",
        "It provides fast results in case of emergencies.",
      ],
    },
    postexpectation: {
      heading: "What to expect after a CT Scan?",
      text: `However, CT scan is the quickest, painless and safest procedure, but depending on the type of CT scan you have undergone, your physician will ask you to follow some precautions. Following are some of the simple things your doctor will advise you to do-`,
      points: [
        "In case of a contrast scan, you will have to drink plenty of water for 24 hours before to flush out the dye used in the procedure.",
        "Acute reactions like redness, itching or irritation may be felt, but if you experience dizziness or difficulty in breathing, then immediately consult your doctor.",
        "Your reports will be available within 24-48 hours, and your primary doctor will explain to you the conditions.",
        "Most people resume their daily activities right after the scan. Few may feel a mild headache, which often goes away on its own.",
      ],
    },
    howsafe: {
      heading: "How safe are the CT scans at the CDC?",
      text: `Although it uses radiation, the levels are controlled in such a way that which is considered safe for patients.
             However, it is prohibited for pregnant women unless and until it is extremely needed.
             It is a modern, advanced medical technology providing detailed images to help doctors diagnose, monitor and treat a wide range of medical conditions.`,
    },

    typerof: [
      {
        heading: "Standard CT Scan for general diagnosis",
        text: "It is one of the most widely used CT scans. It scans the body regions, including the head, chest, abdomen, and pelvis. It can detect problems like infections, fractures, tumours, internal bleeding, and organ disorders. It is usually the initial diagnostic step when a patient shows unclear symptoms",
      },
      {
        heading: "Contrast-Enhanced CT Scan",
        text: "A unique contrast dye is used during this scan, which is either taken orally or injected intravenously (IV) to enhance the visibility of targeted tissues and vessels. The contrast highlights areas that may not be easily visible during a regular scan, including tumours, inflammation, or vascular details for accurate examination.",
      },
      {
        heading: "Helical or Spiral CT Scan",
        text: "It is the newest type of scanning technique that continuously takes images in a spiral pattern as the patient moves through the scanner. It is useful for the evaluation of the lungs, heart, and chest region, providing high-resolution imaging that picks up the pulmonary embolisms, lung nodules, cardiac problems, and more in a more efficient and quicker way.",
      },
      {
        heading: "CT Angiography",
        text: "CT Angiography (CTA) is an advanced scan used to see the blood vessels of the entire body. Using the contrast dye and rapid imaging, it enables doctors to identify obstructions, artery narrowing, or other circulatory issues. It is commonly used for the evaluation of the brain, heart, lungs, kidneys, and limbs for circulatory issues.",
      },
      {
        heading: "CT Colonography",
        text: "It is a non-invasive technique of CT scanning to analyse the colon (large bowel) for polyps, tumours, or other distortions. CT colonography is a useful test for screening colon cancer and is used when patients cannot complete standard colonoscopy tests.",
      },
      {
        heading: "Cardiac CT Scan",
        text: "It is used to examine the heart and the arteries that surround it.  A cardiac CT scan gives clear images of the heart's structure and identifies coronary artery disease, heart abnormalities, and other heart conditions. It is frequently used as a part of preventive heart wellness examinations and to determine which treatment is needed for heart disease.",
      },
    ],
    faqs: [
      {
        question: "How long does a CT scan procedure take?",
        answer:
          "A CT scan may only take around 5 to 10 minutes. It's a quick procedure, but you have to wait for the results.",
      },
      {
        question: "How soon will I get the results?",
        answer:
          "Results are usually available within a few hours to a couple of days.",
      },
      {
        question: "Are CT scans used for children?",
        answer:
          "Yes, it is used for children with caution. Doctors use CT scans for children when absolutely necessary. But they usually use alternative imaging.",
      },
    ],
  },
  {
    image: densitometry,
    alt: "Bone Densitometry",
    title: "Bone Densitometry / DEXA Scan",
    subTitle: "Also called a DEXA scan or Dual-Energy X-ray Absorptiometry.",
    slug: "bone-densitometry",
    extraTopMargin: false,
    bottomTextAbsolute: true,
    description: "Measures bone strength and helps diagnose osteoporosis.",
    shapedImg: BoneShaped,
    content: [
      {
        heading: "What is a CT Scan?",
        text: `Computed Tomography, for short, is also referred to as a CT scan.A CT scan is an imaging medical technology that assists physicians in viewing the internal human body structures in a very clear way without undergoing any surgical procedure.`,
        video: dexz_vdo_1,
      },
      {
        heading: "How does it work?",
        text: `This technology is currently commonly applied both during diagnosis and in emergencies. CT scans are used to diagnose several conditions and disorders, like tumors, internal injuries, infections, blood clots, cardiovascular disease, fractures, and abnormalities in the human brain.
                A CT scan provides cross-sectional images that are far more detailed than any standard X-ray examination.
                While taking the CT scan test, the patient will lie on a slowly moving table that goes into a big circular machine known as a CT scanner. An X-ray source scans around the body, taking aerial pictures from various directions, and these are sorted by powerful computers to provide a whole 3D image.
                Contrast dye may be ingested or injected to highlight internal structures. The scan uses low-dose ionising radiation. Newer machines aim to minimise risk while maximising diagnostic clarity.
                CT scanning is quick, painless, and highly informative—one of the pillars of modern medicine.`,
        video: dexz_vdo_2,
      },
      {
        heading: "Conditions a CT Scan can Detect",
        text: `A CT scan can detect various conditions like `,
        points: [
          "Tumors of cancer",
          "Fractures",
          "Internal bleeding caused due to accidents",
          "Detects kidney stones",
          "Lung diseases",
          "Detects abnormalities in the brain",
        ],
      },
      {
        heading: "Common uses of CT Scan",
        text: `CT scans provide quick and detailed images and identify various medical conditions within the body. They are commonly used for `,
        points: [
          "Diagnosing injuries",
          "Identifying tumours",
          "Assessing infections",
          "Evaluating blood vessels",
          "Assessing the brain",
          "Diagnosing, detecting and monitoring diseases",
        ],
      },
      {
        heading: "Benefits of a CT scan",
        points: [
          "It provides clear, precise and detailed images of internal organs and structures.",
          "It typically takes just a few minutes for a complete diagnosis, and it is a non-invasive procedure.",
          "It helps in identifying a wide range of conditions like tumours, fractures, infections, and more.",
          "It provides 3D images for better assessment with accurate results.",
          "It provides fast results in case of emergencies.",
        ],
      },
      {
        heading: "What to expect after a CT Scan?",
        text: `However, CT scan is the quickest, painless and safest procedure, but depending on the type of CT scan you have undergone, your physician will ask you to follow some precautions. Following are some of the simple things your doctor will advise you to do-
 `,
        points: [
          "In case of a contrast scan, you will have to drink plenty of water for 24 hours before to flush out the dye used in the procedure.",
          "Acute reactions like redness, itching or irritation may be felt, but if you experience dizziness or difficulty in breathing, then immediately consult your doctor.",
          "Your reports will be available within 24-48 hours, and your primary doctor will explain to you the conditions.",
          "Most people resume their daily activities right after the scan. Few may feel a mild headache, which often goes away on its own.",
        ],
      },
      {
        heading: "How safe are the CT scans at the CDC?",
        text: `Although it uses radiation, the levels are controlled in such a way that which is considered safe for patients.
             However, it is prohibited for pregnant women unless and until it is extremely needed.
             It is a modern, advanced medical technology providing detailed images to help doctors diagnose, monitor and treat a wide range of medical conditions.
`,
      },
    ],
    whatIs: {
      heading: "What is a Bone Densitometry / DEXA Scan?",
      text: `A bone density scan is also called a DEXA scan or Dual-Energy X-ray Absorptiometry.
      It is that imaging test which is used to analyse the strength and the density of the human
       bones. The major use of this scan is to identify the risk of fracture and diagnose conditions
        like osteoporosis and osteopenia, which develop with the growing age.It uses low doses of X-rays 
        to compare the bone density based on your age, gender and body size with reference to the already
         set values.It is generally focused on the spine, hip and forearm and it is a painless and non-invasive
          imaging test.`,
      video: dexz_vdo_1,
    },
    significant:{
       heading: "Significance of Bone Density Scan",
      points: [
        "Diagnosis of Osteoporosis, which is a condition where the bone becomes weak and increases the risk of bone fractures.",
        "It helps in examining the risk of fractures, especially in the hip, spine and wrist region.",
        "Based on the bone density scan results, our doctors will be able to provide you with proper medications, treatment and lifestyle changes.",
        "It is highly beneficial for elderly people who are more prone to weak bones as they age.",
        "The bone density test does not take much time, and it is non-invasive with low radiation.",
      ],
    },
    howWork: {
      heading: "How does it works?",
     
      text: `Standard X-rays will only give the result of bone loss when a fracture takes place.
           Bone density scan, on the other hand, is capable of detecting even a minor loss in bone mass, 
           which makes it an important technique in preventive care.This test is widely recommended among
            postmenopausal women, older adults and individuals with a history of bone diseases running in 
            their family or also someone who is more prone to fractures or bone loss.By identifying the thinning 
            of bones prior to which can lead to fractures, this scan helps with guided treatment options, lifestyle changes,
             and medications which is used to help maintain strong and healthy bones throughout life.`,

      video: dexz_vdo_2,
    },
    conditions: {
      heading: "Conditions detected by the Bone Density Scan",
      text: `A Bone Density Scan can detect various conditions like `,
      points: [
        "Checks for Bone health",
        "Warns about Osteopenia",
        "Detects Osteoporosis",
        "Detects risks of fracture in elderly people",
        "Detects bone loss due to age.",
        "Low bone density due to various medical conditions",
        "Bone loss due to nutritional deficiencies",
      ],
    },
    benefits: {
      heading: "Who must consider a Bone Density Scan?",
      points: [
        "Women over 65 years of age are at higher risk of bone loss due to menopause.",
        "Men above 70 years naturally lose bone density with age.",
        "Men above 50 years may develop hidden bone risks.",
        "Elderly people get fractures easily due to weak bones.",
        "People with low body weight develop bone disorders.",
        "Certain medical conditions will weaken bones.",
      ],
    },
    postexpectation: {
      heading: "What to expect during the Bone density scan?",
      points: [
        "This test is completely risk-free, painless and non-invasive. ",
        "You can resume your daily activities right after the scan.",
        "Moreover, the test will take long, but you will have to wait for at least 2 days for the report.",
      ],
    },
    howsafe: {
      heading: "How safe are Bone Density Scans at the CDC?",
      text: `At CDC, we perform the bone density scan very safely, ensuring our patients’ safety. We use very low radiation, yet our procedure is quick and gives accurate results. They are generally non-invasive and painless.At the CDC, Bone density scans are performed under professional supervision with modern and advanced technologies. Our equipment is safe for everyone, but we avoid its use on pregnant women and young children. Otherwise, it is the most effective method to diagnose the overall bone health.`,
    },

    typerof: [
      {
        heading: "DEXA or Dual-Energy X-ray Absorptiometry",
        text: "It is one of the most common and widely used bone density tests, which measures the bone density at the spine and hip regions. These are the areas where fractures are more likely to happen. It is also recommended for postmenopausal women, older adults and people who are at high risk of fractures.",
      },
      {
        heading: "Peripheral DEXA (p-DEXA)",
        text: "This test is generally considered for the smaller regions like the wrist, finger, forearm and heel area. It is a fast and economical test when the full body scan is not really needed, when the goal is only to scan the smaller regions.",
      },
      {
        heading: "Vertebral Fracture Assessment",
        text: "It is a special kind of scan which is performed along with a DEXA scan. Using this scan, the vertebral fractures can be detected, which often went unnoticed during the previous scanning test. It is usually recommended to people who have a long history of complaining about back pain, and there is a reduction in their height.",
      },
    ],
    faqs: [
      {
        question: "How often do I need a scan?",
        answer:
          "It depends on your age and risk factors.Mainly, people get scanned once in 2-3 years.",
      },
      {
        question: "Is it covered by insurance?",
        answer:
          "Yes, we do cover major medical insurance.For more details, you can check with our experts.",
      },
    ],
  },
  {
    image: MAMMOGRAPHY,
    alt: "3D Mammography",
    title: "3D Mammography",
    subTitle: "Used to diagnose breast abnormalities.",
    slug: "3d-mammography",
    extraTopMargin: true,
    bottomTextAbsolute: false,
    description: "Advanced breast cancer screening with 3D imaging.",
    shapedImg: MAMMOGRAPHYShape,
    content: [
      {
        heading: "What is a CT Scan?",
        text: `Computed Tomography, for short, is also referred to as a CT scan.A CT scan is an imaging medical technology that assists physicians in viewing the internal human body structures in a very clear way without undergoing any surgical procedure.`,
        video: CTScanVdo,
      },
      {
        heading: "How does it work?",
        text: `This technology is currently commonly applied both during diagnosis and in emergencies. CT scans are used to diagnose several conditions and disorders, like tumors, internal injuries, infections, blood clots, cardiovascular disease, fractures, and abnormalities in the human brain.
                A CT scan provides cross-sectional images that are far more detailed than any standard X-ray examination.
                While taking the CT scan test, the patient will lie on a slowly moving table that goes into a big circular machine known as a CT scanner. An X-ray source scans around the body, taking aerial pictures from various directions, and these are sorted by powerful computers to provide a whole 3D image.
                Contrast dye may be ingested or injected to highlight internal structures. The scan uses low-dose ionising radiation. Newer machines aim to minimise risk while maximising diagnostic clarity.
                CT scanning is quick, painless, and highly informative—one of the pillars of modern medicine.`,
        video: CTScanVdo2,
      },
      {
        heading: "Conditions a CT Scan can Detect",
        text: `A CT scan can detect various conditions like `,
        points: [
          "Tumors of cancer",
          "Fractures",
          "Internal bleeding caused due to accidents",
          "Detects kidney stones",
          "Lung diseases",
          "Detects abnormalities in the brain",
        ],
      },
      {
        heading: "Common uses of CT Scan",
        text: `CT scans provide quick and detailed images and identify various medical conditions within the body. They are commonly used for `,
        points: [
          "Diagnosing injuries",
          "Identifying tumours",
          "Assessing infections",
          "Evaluating blood vessels",
          "Assessing the brain",
          "Diagnosing, detecting and monitoring diseases",
        ],
      },
      {
        heading: "Benefits of a CT scan",
        points: [
          "It provides clear, precise and detailed images of internal organs and structures.",
          "It typically takes just a few minutes for a complete diagnosis, and it is a non-invasive procedure.",
          "It helps in identifying a wide range of conditions like tumours, fractures, infections, and more.",
          "It provides 3D images for better assessment with accurate results.",
          "It provides fast results in case of emergencies.",
        ],
      },
      {
        heading: "What to expect after a CT Scan?",
        text: `However, CT scan is the quickest, painless and safest procedure, but depending on the type of CT scan you have undergone, your physician will ask you to follow some precautions. Following are some of the simple things your doctor will advise you to do-
 `,
        points: [
          "In case of a contrast scan, you will have to drink plenty of water for 24 hours before to flush out the dye used in the procedure.",
          "Acute reactions like redness, itching or irritation may be felt, but if you experience dizziness or difficulty in breathing, then immediately consult your doctor.",
          "Your reports will be available within 24-48 hours, and your primary doctor will explain to you the conditions.",
          "Most people resume their daily activities right after the scan. Few may feel a mild headache, which often goes away on its own.",
        ],
      },
      {
        heading: "How safe are the CT scans at the CDC?",
        text: `Although it uses radiation, the levels are controlled in such a way that which is considered safe for patients.
             However, it is prohibited for pregnant women unless and until it is extremely needed.
             It is a modern, advanced medical technology providing detailed images to help doctors diagnose, monitor and treat a wide range of medical conditions.
`,
      },
    ],
    whatIs: {
      heading: "What is a 3D mammography?",
      text: `3D mammography is a kind of imaging technique which is used to diagnose the breast, where the 3D images of the breast are captured from several angles, which allows physicians to examine and study the breast and detect the underlying issues. Using this technique, clear and accurate images are obtained.At CDC, we use 3D mammography for regular screening of breast cancer or in individual who have a history of breast cancer running in their family. Physicians generally suggest mammography to women who have developed lumps, have persistent breast pain, nipple discharge, or have a change in the size and shape of the breast.
It will help in clarifying the abnormalities and monitoring the breast health and condition over time.
`,
      video: d_manman_1,
    },
    howWork: {
      heading: "Who should get 3D mammography?",
      points: [
        "Recommended for women over 40 years of age, depending on the condition.",
        "It helps women having dense breast tissue with accurate results on cancer tumours.",
        "When a person has a family history of breast cancer or breast abnormalities.",
        "If you are unsure about your previous mammography reports.",
      ],

      video: d_manman_2,
    },
    conditions: {
      heading: "Conditions that a 3D Mammography detects",
      text: `A 3D Mammography can detect various conditions like `,
      points: [
        "Breast cancer",
        "Non-cancerous tumours",
        "Cysts",
        "Early cancer detection",
        "Changes in the breast",
      ],
    },

    benefits: {
      heading: "Benefits of 3D Mammography",
      points: [
        "Helps in detecting the cancer easily, especially in dense breasts where it often goes unnoticed.",
        "It brings clarity to the false positive cases where something seems serious but turns out to be harmless.",
        "It helps in the early detection of the cancer, so that treatment can be started at an early stage.",
        "It provides the radiologists with a clear picture of the breast from all angles and in layers, helping them to produce a precise result.",
        "It saves patients’ time and money from extra tests and follow-up routines with its one-time, accurate scanning.",
        "It has the power to distinguish between non-cancerous and dangerous changes with utmost precision.",
      ],
    },
    postexpectation: {
      heading: "What to expect during and after 3D Mammography?",
      points: [
        "During the process, your breasts will be compressed, which might be slightly uncomfortable and tight, but will not be painful.",
        "During the process, you will be standing, although your physicians will be taking care of you.",
        "After the scanning is done, you can quickly get back to your regular activities.",
      ],
    },
    howsafe: {
      heading: "How safe is 3D Mammography at Citrus Diagnostic Centre?",
      text: ` At CDC, we use very low radiation power within the FDA-approved limits, which makes our mammography extremely safe. The patient’s exposure to the radiation is very low.3D mammography is the safest screening test for routine check-ups that provides high accuracy. It even accurately catches the true result for women with dense breasts, thus helping in detecting the presence of cancer.`,
    },
    faqs: [
      {
        question: "How often should I get a mammogram done?",
        answer:
          " It is recommended for women over 40 years old once a year.But you will be advised for the test by your doctor based on your health factors.",
      },
      {
        question: "Will the process cause pain?",
        answer:
          "  Throughout the process, you won’t be able to feel any pain, except a bit of compression.",
      },
    ],
  },
  {
    image: DIGITALXRAY,
    alt: "Digital X-Ray",
    title: "Digital X-Ray",
    subTitle: "Digital X-rays are quite similar to traditional X-rays.",
    slug: "digital-xray",
    extraTopMargin: false,
    bottomTextAbsolute: true,
    description: "Quick, non-invasive imaging technique for bones and organs.",
    shapedImg: DIGITALXRAYShape,
    whatIs: {
      heading: "What is X-Rays?",
      text: `Digital X-rays are quite similar to traditional X-rays, which makes it possible for doctors to analyse the patient’s inner body. This imaging test is carried out to examine the injuries in bone, fractures, tumours, any dental problems and other conditions in detail.In digital X-rays, sensors are used which are connected to the computer, which allows for accurate, precise and clear images. It utilises less radiation than the traditional X-ray, which makes it a safer option. Another advantage of using the Digital X-ray is that there is no need to store the images physically; they are stored in electronic devices.`,
      video: digital_xray_1,
    },
    howWork: {
      heading: "How does it work?",
      text: `Digital X-rays are so advanced that there is no need for chemical film processing, and this is the reason which makes it an environmentally friendly technique and produces faster test results. Using this image testing, doctors are able to zoom, adjust brightness and highlight the affected region for more accurate diagnosis. Because of its quality, it has now become the top choice among various healthcare units.`,
      video: digital_xray_2,
    },
    conditions: {
      heading: "What conditions do Digital X-ray detect?",
      text: `A Digital X-ray can detect various conditions like `,
      points: [
        "Fractures",
        "Bone infection and dislocation",
        "Underlying joint issues",
        "Presence of cancer, like Lung cancer",
        "Pneumonia and Tuberculosis",
        "Detects foreign material in the lungs",
        "Tooth decay and dental issues",
        "Bone abnormalities in children",
        "Detects tumors",
      ],
    },

    benefits: {
      heading: "Benefits of Digital X-ray",
      points: [
        "Digital X-rays need very low radiation, which makes them safe for children.",
        "Image results are quickly available, which makes the further treatment process fast.",
        "With digital X-rays, images produced are in detailed and clearer.",
        "Digital images produced can be stored in electronic devices and can be shared easily.",
      ],
    },
    postexpectation: {
      heading: "What to expect during and after the Digital X-ray?",
      points: [
        "For particular scans, you will be asked to hold your breath to get a clear picture free from blur.",
        "If the scanning involved the use of an external agent, then you will be asked to drink plenty of water to flush it out after the test is done.",
      ],
    },
    howsafe: {
      heading: "How safe is Digital X-ray at Citrus Diagnostic Centre?",
      text: `Digital X-rays at Citrus Diagnostic Centre are very safe by following the safety guidelines for patients. Our X-ray machine uses 80% less radiation than the traditional machines and generates high-quality nd clear images.
             We are accredited by the ACR and meet the standards of radiation safety by following all the protocols. It sets our diagnostic centre safe and ensures the safety of our patients.`,
    },
    typerof: [
      {
        heading: "Computed Radiography",
        text: "In this digital X-ray technique, phosphorus plates are used to capture the image, which is then digitally stored. It is used in dental imaging, non-destructive testing and veterinary imaging.",
      },
      {
        heading: "Direct Digital Radiography",
        text: "In this process, the X-rays are directly converted into images without needing to pass through any intermediaries. This facility provides me with the most convenient and fastest way to get the results.",
      },
    ],
    faqs: [
      {
        question: "Can I see the images instantly?",
        answer:
          "As the images produced are digital so you can see them on the computer screens.Although your doctor will explain to you about the image.",
      },
      {
        question: "What if I already had a lot of X-rays?",
        answer:
          "Our radiologists will perform the X-ray only when it is really needed.Moreover, digital X-rays at the CDC are safe with low radiation emission.",
      },
    ],
  },
  {
    image: ECHOCARDIOGRAPHY,
    alt: "Echocardiography",
    title: "Echocardiography",
    subTitle: "A diagnostic test also called the echo test.",
    slug: "echocardiography",
    extraTopMargin: true,
    bottomTextAbsolute: false,
    description:
      "Ultrasound of the heart to assess heart function and structure.",
    shapedImg: ECHOCARDIOGRAPHYShape,

    whatIs: {
      heading: "What is Echocardiography?",
      text: `Echocardiography is a diagnostic test which sometimes also called the echo test. It uses sound waves and creates real-time images of the heart. This test allows doctors to examine the condition of the heart, heartbeats, and its function. It is widely used by cardiologists and performed by experienced professionals only.`,
      video: cardio_vdo_1,
    },
    howWork: {
      heading: "How does it work?",
      text: `Echocardiography uses the sound waves of high-frequency which are transferred from the device called transducer which is held by the physician over the patient’s chest, which are then bounced back by the heart and is then converted into an image which is displayed on the screen immediately.`,
      video: cardio_vdo_2,
    },
    conditions: {
      heading: "Conditions Echocardiography can Detect",
      text: `A Echocardiography  can detect various conditions like `,
      points: [
        "Heart failure",
        "Aortic diseases",
        "Abnormal heart function",
        "Clots in the heart",
        "Cardiac tumor",
        "Endocarditis",
        "Coronary artery disease",
        "Pericardial disease",
        "Heart defects",
        "Cardiomyopathy",
        "Heart valve diseases",
      ],
    },
    usecase: {
      heading: "Who needs Echocardiography?",
      points: [
        "When people experience chest pain or shortness of breath.",
        "People who deal with high blood pressure.",
        "People who have a history of strokes, heart conditions or heart attacks.",
        "Doctors prescribe it to people who have undergone heart surgeries.",
        "Sports persons or others who need to undergo cardiac evaluation.",
      ],
    },
    benefits: {
      heading: "Benefits of Echocardiography",
      points: [
        "It is a completely non-invasive and painless procedure with low risk involved due to no radiation.",
        "It helps in assessing the heart's pumping and valve function instantly through live visuals of heartbeats.",
        "It helps in preventing complications by detecting heart conditions at an early stage.",
        "It is the quick, convenient and economic procedure.",
      ],
    },
    postexpectation: {
      heading: "hat to expect after an Echocardiography?",
      text: `As echocardiography uses sound waves to examine the heart's functioning, it is completely safe, and one can resume their routine`,
      points: [
        "If the gel was used in the process, then you can freely wipe off the remaining gel residue at home with soap and water to get rid of stickiness",
        " Your report will be ready in 2 days, and your doctor will explain to you the next steps.",
      ],
    },
    howsafe: {
      heading: "How safe is echocardiography at Citrus Diagnostic Centre?",
      text: `At the CDC, we strictly follow the standard rules for safety and provide quality imaging services. Echocardiography is one among them. It is a completely non-invasive and painless procedure which uses just the sound waves to create the internal images of the heart with no risk to the patients.`,
    },

    typerof: [
      {
        heading: "Transthoracic Echocardiography",
        text: "It is generally used for a normal heart check-up and is standard echocardiography. It helps in evaluating the size and shape of the heart, analysing the pumping strength of the heart, observing the blood flow and checking for any leakages in the heart valve.",
      },
      {
        heading: "Transesophageal Echocardiography",
        text: "It is a special type of echocardiography where the high-frequency sound waves are used to capture clear and precise heart images, but in this technique, the transducer device is passed beneath the chest with a little bit of incision. Which helps in getting a clear and detailed image of the heart. It helps in detecting the causes of heart stroke, defects in the heart and various infections.",
      },
      {
        heading: "Fetal Echocardiography",
        text: "It is carried out on pregnant women to detect the heart health of fetuses of the unborn baby. It i typically carried out around the 18-24 weeks of the pregnancy.",
      },
    ],
    faqs: [
      {
        question:
          "Will my anxiety or nervousness affect the result in echocardiography?",
        answer:
          "In most cases, it won’t affect the actual test result, but if you are more concerned about it then you can talk with your doctor.",
      },
      {
        question: "Do I need to repeat the test?",
        answer:
          "It completely depends on your heart condition.Your doctor will recommend when to have one.",
      },
    ],
  },
  {
    image: NUCLEARMEDICINE,
    alt: "Nuclear Medicine",
    title: "Nuclear Medicine",
    subTitle: "Advanced level of diagnostic tests.",
    slug: "nuclear-medicine",
    extraTopMargin: false,
    bottomTextAbsolute: true,
    description: "Uses small amounts of radioactive material for diagnosis.",
    shapedImg: NUCLEARMEDICINEShape,

    whatIs: {
      heading: "What is Nuclear Medicine?",
      text: `Nuclear medicine is a modern and advanced level of diagnostic tests. It is that branch of medical science in the field of imaging which involves the use of radioactive substances. These radioactive substances are called tracers, which are used in small and safe amounts. These tracers are introduced into the body to capture the visuals of the internal structure and functioning of the organs and tissues.Nuclear medicine paves the way for radiologists and physicians to study the different body parts and their functioning in real-time. Thus, providing the precise results and making it a powerful technique for early and accurate detection of diseases.`,
      video: nuclear_1,
    },
    howWork: {
      heading: "How does it work?",
      text: `This test is greatly helpful in detecting conditions like cancers, heart diseases, neurological disorders, and bone infections, even before they show symptoms or any changes are noticed or occur. It even helps in analysing the spread of the particular diseases and monitoring their progress, which will effectively help in planning a suitable treatment plan according to the needs of each patient.With the intervention of the latest technology with advanced medical insights from the professionals, it is highly accurate, non-invasive and patient-friendly, which helps in faster diagnosis and effective treatment plans, which are conducted by the skilled physicians, ensuring patients’ safety.`,
      video: nuclear_2,
    },
    conditions: {
      heading: "Conditions detected by Nuclear Medicine",
      text: `A Nuclear Medicine can detect various conditions like `,
      points: [
        "Various heart-related conditions",
        "Detect and monitor the cancer",
        "Various bone disorders",
        "Detect various kidney problems",
        "Detects lung problems",
        "Infections in various body parts",
        "Internal bleeding causes",
        "Examines the heart condition",
      ],
    },
    usecase: {
      heading: "Who needs a Nuclear Medicine Scan?",
      points: [
        "People dealing with unexplained swelling, pain and weakness.",
        "Examining the damage to the heart after a heart attack.",
        "Analysing the blood flow to the heart.",
        "To examine the cancer.",
        "Dealing with bone pain and detecting fractures which got missed on the X-rays.",
        "It is needed when other imaging tests are ineffective.",
      ],
    },
    benefits: {
      heading: "Benefits of Nuclear Medicine",
      points: [
        "It helps in the early detection of conditions before they damage the organ.",
        "The procedure is simple and does not need surgical intervention.",
        "Provides a clear image of the working of the organs.",
        "It can scan the entire body in one go, and the radioactive material used leaves the body naturally without causing any harm.",
      ],
    },
    postexpectation: {
      heading: "What to expect after a Nuclear Medicine Test?",
      text: `Usually, after the nuclear medicine test, most people feel completely normal and can actively do their normal activities. However, your physician will advise you to follow some things like-`,
      points: [
        "You will have to drink plenty of water for the next 24 hours in order to flush out any radioactive materials.",
        "Your report will be ready within 24–48 hours, which is then sent to your referring doctor with whom you will discuss the next steps.",
        "For safety reasons, it is advised to avoid close contact with pregnant women or infants so that even the tiniest amount of radiation does not get transferred.",
        "Although there are rarely any side effects after the test, you may feel a little tired and see redness around the injection site, which will vanish on its own after some time.",
        "Even if you feel something unusual, it is good to reach out to your doctor.",
      ],
    },
    howsafe: {
      heading:
        "How safe are the Nuclear Medicine tests at Citrus Diagnostic Centre?",
      text: `At the CDC, the nuclear medicine test is performed under the expert guidance of trained professionals, ensuring the safety of the patients. They use a small amount of radioactive tracer to get a clear image with minimum exposure. These tracers leave he body naturally without harming the internal organs within a few hours of the test.`,
    },

    typerof: [
      {
        heading: "Whole body bone scan",
        text: "A radiotracer is used in this procedure, which examines the overall activity in the entire body. With the use of the SPECT system or gamma cameras, the images are taken to identify the abnormality present in the bone, which can either be bone infection, bone cancer or others. It also identifies the fracture.",
      },
      {
        heading: "Renal Scan",
        text: "It is used to scan and detect the underlying issues in the kidney and is also used to indicate the presence of obstruction or renovascular hypertension. It helps in examining the blood flow and kidney function. Here, the tracer is processed by the kidney, which then the camera captures real-time images about the function of the kidney and also gets the visuals of the urine being excreted. It is safe, non-invasive and used to diagnose urinary tract issues, Renal artery stenosis, and kidney infections.",
      },
      {
        heading: "Thyroid Scan",
        text: "With the help of a thyroid scan, the functioning and structure of the thyroid gland are examined, and the test is usually carried out when thyroid issues are suspected. A small amount of tracer is induced into the thyroid tissue, which is then monitored by the gamma camera to get detailed images of the gland. This scan will provide insights about the presence of conditions like hyperthyroidism, hypothyroidism, thyroid nodules, goiter, or thyroid cancer.",
      },
      {
        heading: "Gallbladder scan",
        text: "It is also called hepatobiliary iminodiacetic acid is used to evaluate patients suspected of the gallbladder diseases. This scan will examine the overall functioning of the gallbladder when the tracer is induced, which then travels through the liver, gallbladder, bile ducts and the small intestine. Then the gamma camera will clearly capture the real-time images, which help in diagnosing conditions like gallbladder inflammation, dysfunction or blockages.",
      },
      {
        heading: "Cardiac Scan:",
        text: "It is more commonly known as a myocardial perfusion scan or nuclear stress test. This test is effectively used to examine the blood flow to the heart at rest and in stress. In this test, a tracer is injected into the blood, which is then captured using the gamma camera the visualise the heart. This scan will effectively detect the damage caused to the heart and the occurrence of future heart attacks.  It also diagnoses he blockages and other coronary diseases.",
      },
      {
        heading: "Cardiac CT Scan",
        text: "It is used to examine the heart and the arteries that surround it.  A cardiac CT scan gives clear images of the heart's structure and identifies coronary artery disease, heart abnormalities, and other heart conditions. It is frequently used as a part of preventive heart wellness examinations and to determine which treatment is needed for heart disease.",
      },
    ],
    faqs: [
      {
        question: "Are there any side effects of a nuclear medicine test?",
        answer:
          "There are rarely any side effects of the test, and people have felt completely normal.",
      },
      {
        question: "Can I take a nuclear medicine scan when I’m pregnant?",
        answer:
          "If you are in need to take the nuclear medicine test, then special precautions will be taken from our side. But to ensure safety, we would also recommend alternative techniques",
      },
    ],
  },
  {
    image: MRI,
    alt: "MRI",
    title: "Open & High-Field 1.5T MRI",
    subTitle: "MRI is short for Magnetic Resonance Imaging.",
    slug: "mri",
    extraTopMargin: true,
    bottomTextAbsolute: false,
    description:
      "Detailed soft-tissue imaging using magnetic fields and radio waves.",
    shapedImg: MRIShape,

    whatIs: {
      heading: "What is a MRI?",
      text: `MRI is short for Magnetic Resonance Imaging.It is an imaging technique which helps in creating a detailed and clear picture of the inside of the human body. It makes use of the magnetic field, radio waves and a computer. These all combine to create high-resolution images without any use of harmful radiation.`,
      video: high_mri_1,
    },
    howWork: {
      heading: "How does it work?",
      text: `It can generate the images of almost any part of the body and can effectively diagnose conditions like stroke, brain tumours, blockages and heart damage, bone infections, disc misplacement or problems related to the abdominal area.During an MRI, the patient is made to lie inside the cylindrical magnetic compartment where the strong magnetic field is created that aligns with the hydrogen atoms in the body. Then these atoms generate certain signals which are caused due to the radiofrequency. Then the computer captures these signals precisely nd creates a 3d image.`,
      video: high_mri_2,
    },
    conditions: {
      heading: "What are the conditions detected by MRI?",
      text: `A MRI can detect various conditions like `,
      points: [
        "Detects a brain tumour",
        "Identifies brain injuries",
        "Detects the location of the cancer",
        "Identifies infectious tissues",
        "Injuries in any part of the body",
        "Detects vascular disorders",
        "Abnormalities present in the body",
      ],
    },
    usecase: {
      heading: "Who needs an MRI?",
      points: [
        "People have complaints of back, neck or joint pain.",
        "Suffering from severe brain or headaches.",
        "People got injured during sports.",
        "People who were monitored with tumours or other severe diseases.",
        "In some cases, pregnant women when ultrasound did not work effectively.",
        "Before surgery to plan the major surgeries effectively.",
        "People with brain or heart abnormalities.",
      ],
    },
    benefits: {
      heading: "Benefits of MRI",
      points: [
        "It is a completely painless and non-invasive procedure.",
        "It is safe, as no radiation is used other than magnetic waves and radio waves.",
        "It produces high-quality and detailed images, which help doctors detect diseases at an early stage.",
      ],
    },
    postexpectation: {
      heading: "What to expect during and after an MRI?",
      points: [
        "MRI machines will make some noise, and for that, you will be given earplugs to cancel out the noise.",
        "The test takes around 20–40 mins. You will have to stay still to get the best results.",
        "Due to the dye used, you may feel a metallic taste in your mouth, which goes away on its own with time.",
        "You will need to drink plenty of water to flush out the dye residue from your body completely.",
        "If you experience any unusual signs like dizziness or irritation, immediately contact your doctor.",
      ],
    },
    howsafe: {
      heading: "How safe is an MRI at Citrus Diagnostic Centre?",
      text: `At CDC, we perform the MRI scan of our patients, keeping in mind the health guidelines that follow the patient’s safety. Although our MRI machines are super advanced and only make use of magnetic and radio waves without any of the radiation.`,
    },

    typerof: [
      {
        heading: "SContrast MR",
        text: "In this MRI scan, a contrast dye is induced in the bloodstream during the scanning process, which helps in enhancing the visibility of certain body regions like soft tissues and blood vessels, which helps in generating detailed images. Doctors usually recommend this scan when they have to distinguish between normal and abnormal tissues, examine the blood flow, and monitor the spread of the cancer.",
      },
      {
        heading: "Functional MRI",
        text: "It helps in monitoring and examining brain activities by examining the blood flow in the brain. The idea that applies is that the active functioning area of the brain will need more oxygen supply, while the inactive area will have insufficient blood supply. So, doctors are able to analyse which part of the brain is functioning and which is not during a particular task.",
      },
      {
        heading: "Cardiac MRI",
        text: "It provides high-quality images of the heart structure, heart muscle, chambers, blood vessels and helps in the diagnosis of complicated heart conditions like heart tumours, cardiomyopathy, congenital heart disease and much more.",
      },
    ],
    faqs: [
      {
        question:
          "What if I don't remain completely still during the MRI scan?",
        answer:
          "Although it is recommended to remain completely still during the scan, as movement can cause blurry images. But the technicians will support you.",
      },
      {
        question: "What if I sleep during the MRI scanning?",
        answer:
          "It is completely fine even if you fall asleep. As many people find the MRI environment relaxing",
      },
    ],
  },
  {
    image: PET,
    alt: "PET/CT",
    title: "PET/CT",
    subTitle: "Positron Emission Tomography, or a PET scan.",
    slug: "pet-ct",
    extraTopMargin: false,
    bottomTextAbsolute: true,
    description:
      "Combines PET and CT imaging for functional and structural details.",
    shapedImg: PETShape,

    whatIs: {
      heading: "What is a PET/CT Scan?",
      text: `Positron Emission Tomography, or more popularly called a PET scan, is a kind of medical imaging test which is used to examine the working of organs and functioning of tissues inside the human body. This scan not only shows how the organ looks but also displays the actual working of the organ. A PET scan helps to detect the presence of certain diseases even before they show any changes.`,
      video: CTScanVdo,
    },
    howWork: {
      heading: "How does it work?",
      text: `It uses a small amount of radioactive tracer to identify the abnormal activity in the body and helps in detecting diseases like cancer, brain disorders or heart problems. It is carried out by injecting a small amount of radiotracer into the veins, which travels through the bloodstream and gets absorbed by the abnormal cells. Then the PET will act on the radiation produced by the tracer, which is then captured is converted into the image.`,
      video: high_mri_2,
    },
    conditions: {
      heading: "Condition PET can diagnose",
      text: `A PET scan can detect various conditions like `,
      points: [
        "Brain tumors",
        "Dementia",
        "Various neurological diseases",
        "Injuries to the brain",
        "Various cancer detection",
        "Analysis of blood flow to the heart",
        "Coronary artery disease",
        "Unexplained fever",
        "Bone infections",
        "Bowel diseases",
        "Detects the reason for recurring cancer",
      ],
    },
    usecase: {
      heading: "Who needs a PET scan?",
      points: [
        "People who suspect they have cancer",
        "To check the spread of cancer",
        "To affirm the recurrence of cancer",
        "People dealing with memory loss",
        "People with declining cognitive abilities",
        "People dealing with movement",
        "Patients with heart diseases",
        "People experiencing unexplained fever and weight loss",
        "Pre-surgery follow-up scan",
      ],
    },
    benefits: {
      heading: "Benefits of having a PET scan",
      points: [
        "They are able to detect the presence of diseases earlier, even before they start to show symptoms.",
        "It precisely distinguishes between non-cancerous and cancerous cells.",
        "It accurately determines the spread of cancer to other organs in the body.",
        "Using a PET scan, a doctor is able to scan the entire body in one go.",
        "It helps in preventing unnecessary treatments and surgeries due to the precise diagnosis.",
      ],
    },
    postexpectation: {
      heading: "What to expect during and after the PET scan?",
      points: [
        "As a radioactive tracer is injected into your body, you will be asked to rest for about an hour as it travels throughout your body.",
        "The entire process is painless, but you will have to stay still for better results.",
        "In rare cases, you will have to rest for a few hours after the scan and need someone to accompany you.",
        "You will have to drink plenty of water to flush out the radioactivity from your body.",
        "You should maintain a distance from pregnant women and infants until the radioactive tracer is in your body.",
        "If you experience rashes, redness or irritation after the test, then consult your doctor.",
      ],
    },
    howsafe: {
      heading: "How safe is a PET scan at Citrus Diagnostic Centre?",
      text: `At the CDC, our expert radiologists perform the PET scan on our patients under professional supervision, ensuring the safety of the patients. The radioactive tracer, which is used while scanning, is in a very small amount and disappears from the body within a few hours of the test.Being an ACR-accredited diagnostic centre,  our professionals perform the scanning under expert supervision with advanced technologies, following the strict safety protocols. Our patients have experienced no side effects after the scan in our entire medical history.`,
    },

    typerof: [
      {
        heading: "PET/CT ",
        text: "It is the combination of PET and CT scanning which provides the most precise location of the abnormal cell. It is used in the oncology department to detect tumours, check for cancers, and monitor the response to the treatment.",
      },
      {
        heading: "PET/MR",
        text: "It is the combination of PET with the MRI scanning which considered the best option for detecting pelvic cancer, neurological conditions and pediatric conditions with the use of less radioactive tracer.",
      },
      {
        heading: "Brain PET scan",
        text: "It is a specialised scanning test which detects Alzheimer's disease and Parkinson’s disease. It also detects Epilepsy, brain tumours and injuries to the brain.",
      },
    ],
    faqs: [
      {
        question: "Whether the radioactive material harmful?",
        answer:
          "It is actually safe, and at the CDC, we use it in a very low quantity, and it gets passed out of your body naturally within a few hours of the test.",
      },
      {
        question: "Is the scan safe for people with allergies?",
        answer:
          "Yes, it is safe for people with allergies.The substance would rarely cause any side effects.",
      },
    ],
  },
  {
    image: ULTRASOUND,
    alt: "Ultrasound",
    title: "Ultrasound",
    subTitle: "Also called sonography, safest imaging method.",
    slug: "ultrasound",
    extraTopMargin: true,
    bottomTextAbsolute: false,
    description: "Uses sound waves to visualize organs and soft tissues.",
    shapedImg: ULTRASOUNDShape,
    whatIs: {
      heading: "What is Ultrasound?",
      text: `Ultrasound is also called sonography and is the safest imaging method. This imaging process uses high-frequency sound waves to get the images from inside the body. It is safe because it does not utilise radiation substances, which makes it the ideal choice for all patients, whether pregnant women or children.In ultrasound, a water-soluble gel is applied over the skin, and then a device called a transducer is placed over that region. This helps to send the sound waves inside the body. When these sound waves travel into the body, they bounce back from the internal structures and a live image is created on the monitor.`,
      video: ultrasound_1,
    },
    howWork: {
      heading: "How does it work?",
      text: `The Ultrasound is widely used to monitor the organs like kidneys, gallbladder, uterus, liver, ovaries and urinary bladder. It also captures the blood flow in arteries and veins.The major use of ultrasound is in monitoring the growth and development of the fetus in pregnant women. Cardiologists too use the ultrasound method to asses the heart health of the patients. All these are possible because it is a radiation-free diagnostic tool which is highly versatile in providing valuable diagnostic information to support the proper treatment.`,
      video: ultrasound_2,
    },
    conditions: {
      heading: "Conditions detected by Ultrasound",
      text: `A Ultrasound can detect various conditions like `,
      points: [
        "Pregnancy",
        "Ectopic pregnancy",
        "Fetal development",
        "Presence of fibroids and ovarian cysts",
        "Gallstones",
        "Appendicitis",
        "Hernias",
        "Infections in the tissues",
        "Heart diseases",
        "Varicose veins",
      ],
    },
    usecase: {
      heading: "Uses of Ultrasound",
      points: [
        "To confirm pregnancy",
        "To monitor fetal health and development",
        "To examine the abdominal organs for any abnormalities",
        "To examine the pelvic region",
        "To detect the abnormalities in the breast",
        "To determine the endometrial conditions",
      ],
    },
    benefits: {
      heading: "Benefits of Ultrasound",
      points: [
        "It is a safer option as there is no involvement of any harmful radiation.",
        "It is non-invasive, comfortable and does not cause any pain.",
        "It hardly takes 20-30 minutes and provides real-time imaging.",
        "It provides accurate and precise imaging results",
      ],
    },
    postexpectation: {
      heading: "What to expect after an Ultrasound?",
      text: `People usually feel completely safe and resume their daily activities with no restriction. However`,
      points: [
        "You may be asked to drink a lot of water and avoid urinating until the tests are done, so you may feel slight discomfort.",
        "Your reports will be shared with your doctor, where you can discuss further steps.",
        "In case you start experiencing any pain after the test, then immediately inform your doctor.",
      ],
    },

    typerof: [
      {
        heading: "3D Ultrasound",
        text: "In 3D ultrasound, the 2D images are captured from all angles, which are then arranged together to form a 3D image. This image is very clear and gives an accurate glimpse of the organs. It is generally used in gynaecology and oncology to examine the organs in more detail.",
      },
      {
        heading: "Doppler Ultrasound",
        text: "Doppler ultrasound is widely used to monitor the blood flow from the vessels to the body. In this technique, a high-frequency sound wave bounces off the red blood cells, which are circulating in the bloodstream. Unlike the regular ultrasound, Doppler ultrasound is able to show the flow of blood effectively. It helps in the diagnosis of various conditions like heart valve defects, blocked arteries, and poor blood circulation.",
      },
      {
        heading: "Obstetric Ultrasound",
        text: "It is also called obstetric ultrasonography or prenatal ultrasound, which uses sound waves ar use to get the real-time images of the fetus or the growing embryo in the pregnant woman. It is the primary health care routine among pregnant women from all over the world. It is capable of providing important information like pregnancy timing, progress in the pregnancy and health of the embryo and fetus.",
      },
      {
        heading: "Abdominal ultrasound",
        text: "It is a type of ultrasound where patients can get internal visuals of their abdominal organs. It is used to diagnose the various issues related to the kidney, liver, and gallbladder and is also used to address abdominal pain.",
      },
      {
        heading: "Musculoskeletal Ultrasound",
        text: "Musculoskeletal Ultrasound or MSK ultrasound is a type of ultrasound technique which examines the muscles, tendons, joints and ligaments and is used to get the internal images of these regions to detect any injuries or inflammations. It is capable of detecting muscle strains, sprains in ligaments, bursitis, problems in joints, or insertion of a foreign object.",
      },
    ],
    faqs: [
      {
        question: "Will the gel used in he process cause any allergies?",
        answer:
          "The gel used is water soluble and hypoallergenic, which will rarely cause any kind of allergies.",
      },
      {
        question: "Can I have an ultrasound again and again?",
        answer:
          "Although it is a safe method, and can be carried out depending on your medical needs and as prescribed by your physicians.",
      },
    ],
  },
];

export default imagingServicesdata;
